import { isWebViewFarmi } from '@b2ag/farmi-app-appro-tools'
import { isFarmi } from '@b2ag/app-brands'

import { PAGE_TYPE } from '../page-types'
import { useRequestHeader } from '#imports'
import type { RouteLocationNormalized, RouteLocationNormalizedLoaded, NavigationGuardNext } from 'vue-router'

/* ------- MICROFRONT - PORTAL ------- */

export const portalRoutes = [
  {
    path: '/',
    name: 'portal-home',
    component: () => import('@b2ag/micro-front-portal/app'),
    props: () => ({
      microFrontName: 'portal',
      viewName: 'home',
    }),
    meta: {
      hideHeaderMenu: false,
    },
  },
  {
    path: '/collect',
    name: 'portal-collect',
    component: () => import('@b2ag/micro-front-portal/app'),
    props: () => ({
      microFrontName: 'portal',
      viewName: 'collect',
    }),
    meta: {
      hideHeaderMenu: true,
    },
  },
  {
    path: '/agro-pilot',
    name: 'portal-agro-pilot',
    component: () => import('@b2ag/micro-front-portal/app'),
    props: () => ({
      microFrontName: 'portal',
      viewName: 'agro-pilot',
    }),
    meta: {
      hideHeaderMenu: true,
    },
  },
  {
    path: '/cp/:page',
    name: 'portal-contentful-page',
    component: () => import('@b2ag/micro-front-portal/app'),
    props: (route: RouteLocationNormalized) => ({
      microFrontName: 'portal',
      viewName: route.params.page,
    }),
    meta: {
      hideHeaderMenu: true,
    },
  },
  {
    path: '/shop',
    name: 'portal-shop',
    component: () => import('@b2ag/micro-front-home/app'),
    props: () => {
      return {
        microFrontName: 'home',
        viewName: 'home',
      }
    },
    beforeEnter(_to: RouteLocationNormalized, _from: RouteLocationNormalizedLoaded, next: NavigationGuardNext) {
      if (isFarmi && isWebViewFarmi(useRequestHeader('user-agent'))) {
        next({ name: 'farmi-app-appro-categories' })
      } else {
        next()
      }
    },
    meta: {
      analyticsPageType: PAGE_TYPE.HOME,
    },
  },
]
